<op-sidemenu
  [items]="menuItems$ | async"
  data-test-selector="op-sidemenu"
></op-sidemenu>
